export default __webpack_public_path__ + "static/iPhoneFrameFullBlack-618afa0ca7c981fd0f174355eaafdcc0.png";